module.exports = __webpack_public_path__ + "static/media/step-4.6e8e5bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/how-it-works/stepper-how-it-works/step-4.png
// module id = 2264
// module chunks = 0